import getMenuData from './mock/getMenu.json' // restful api를 사용하지 않을 경우
import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'

// 메뉴에 쓸 프로그램 가져오기
export function getMenuProg(param) {
  let isTest = false;

  if (!isUseAPI() || isTest) {
    return new Promise(function(resolve, reject) {
      let res = getMenuData
      console.log("api", res )
      resolve(res.msg)      
    })
  }
  return request({
    url: '/api/getMenuProg',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
  })
}

// 메뉴 조회
export function getMenuManage(param, isNotify) {
  let isTest = false;

  if (!isUseAPI() || isTest) {
    return new Promise(function(resolve, reject) {
      let res = getMenuData
      console.log("api", res )
      resolve(res.msg)      
    })
  }
  return request({
    url: '/api/getMenuManage',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}


// 메뉴관리 저장
export function saveMenuManage(param, isNotify) {
  let isTest = false
  let data = param
  return request({
    url: `/api/saveMenuManage`,
    method: 'POST',
    data,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

// 메뉴관리 삭제
export function deleteMenuManage(param, isNotify) {
  let data = param
  return request({
    url: `/api/deleteMenuManage`,
    method: 'POST',
    data,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}
